import { firebaseApp } from "constant";
import { child, get, getDatabase, ref } from "firebase/database";
import { useEffect, useState } from "react";

const USER_PLAN_TIMEOUT_MS = 2500;

export default function useUserIsPro(uid: string | null) {
  const [loading, setLoading] = useState(false);
  const [isPro, setIsPro] = useState(false);

  useEffect(() => {
    let isActive = true;

    const getIsPro = async () => {
      if (!uid) {
        setIsPro(false);
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const db = getDatabase(firebaseApp);
        const plansRef = child(ref(db), `user_plans/${uid}/plans`);
        const snapshot = await Promise.race([
          get(plansRef),
          new Promise<null>((resolve) =>
            setTimeout(() => resolve(null), USER_PLAN_TIMEOUT_MS)
          ),
        ]);
        const plans = snapshot?.exists() ? snapshot.val() : {};
        const hasActivePlan = Object.values(plans).some(
          (plan: any) => plan?.active === true
        );

        if (isActive) setIsPro(hasActivePlan);
      } catch {
        if (isActive) setIsPro(false);
      } finally {
        if (isActive) setLoading(false);
      }
    };

    getIsPro();

    return () => {
      isActive = false;
    };
  }, [uid]);

  return [isPro, loading] as const;
}
